import React, { useState, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import { MenuManagerIcon } from '@slerp/assets'
import { QUERY_STREAM_SSO_REDIRECT } from './../Stream/StreamQueries'
import { Link } from 'react-router-dom'
import Menu from 'antd/lib/menu'
import { message } from 'antd'
import styled from '@emotion/styled'
import { useMerchant } from 'hooks/useGlobalContext'

const Redirect = styled.a`
  color: #1890ff;
  text-decoration: underline;
  &:hover {
    color: #40a9ff;
  }
`

const StreamRedirect = () => {
  const { integrations } = useMerchant()
  const [merchantPartners, setMerchantPartners] = useState<string[]>([])

  useEffect(() => {
    if (integrations.length > 0) {
      setMerchantPartners(
        integrations.map((integration) => integration.partner.name)
      )
    }
  }, [integrations])

  const getErrorMessage = (msg: string) => {
    switch (msg) {
      case 'Merchant contact_num not found':
        return (
          <span>
            Missing Company Phone Number. Update your trading details{' '}
            <Redirect href='/settings/general' target='_blank'>
              <span>here</span>
            </Redirect>{' '}
            and retry the login.
          </span>
        )
      default:
        return (
          <span>
            We couldn’t connect to your Stream account. Please log in directly
            to Stream using{' '}
            <Redirect
              href='https://slerp.streamorders.com/welcome'
              target='_blank'
            >
              this URL.
            </Redirect>
          </span>
        )
    }
  }

  const [getStreamSsoRedirect] = useLazyQuery(QUERY_STREAM_SSO_REDIRECT, {
    onCompleted: (data) => {
      window.open(data.generateStreamSso.redirect_url, '_blank')
    },
    onError: (error) => {
      const errMsg = getErrorMessage(error.message)

      message.destroy()
      message.error(errMsg)
    }
  })

  const handleStreamRedirect = () => {
    message.destroy()
    message.success('Signing in to menu manager...')

    getStreamSsoRedirect()
  }

  // @ts-ignore
  if (merchantPartners.includes('stream')) {
    return (
      <Menu.Item key='stream'>
        <a
          onClick={() => {
            handleStreamRedirect()
          }}
          className='sidebar-tooltip'
          target='_blank'
        >
          <MenuManagerIcon className='anticon' />
          <span>Menu Manager</span>
        </a>
      </Menu.Item>
    )
  }

  if (
    merchantPartners.some((partner) =>
      ['deliverect', 'urban-piper'].includes(partner)
    )
  ) {
    return null
  }

  return (
    <Menu.Item key='stream'>
      <Link to='/slerp-menu-manager' className='sidebar-tooltip'>
        <MenuManagerIcon className='anticon' />
        <span>Menu Manager</span>
      </Link>
    </Menu.Item>
  )
}

export default StreamRedirect
